import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { createOrReplaceDevBoxAddOnListenerSaga } from './create-or-replace-dev-box-add-on';
import {
    enableDevBoxAddOnListenerSaga,
    enableDevBoxAddOnWithPollingAcceptedListenerSaga,
    enableDevBoxAddOnWithPollingListenerSaga,
} from './enable-dev-box-add-on';
import { enableDevBoxTunnelListenerSaga } from './enable-dev-box-tunnel';
import { getDevBoxAddOnListenerSaga } from './get-dev-box-add-on';
import { listDevBoxAddOnsListenerSaga } from './list-dev-box-add-ons';
import { loadDevBoxAddOnsForDevBoxesListenerSaga } from './load-dev-box-add-ons-for-dev-boxes';
import { pollNonTerminalDevBoxAddOnListenerSaga } from './poll-non-terminal-dev-box-add-on';

export function* rootSaga(): SagaIterator {
    yield all([
        fork(listDevBoxAddOnsListenerSaga),
        fork(loadDevBoxAddOnsForDevBoxesListenerSaga),
        fork(pollNonTerminalDevBoxAddOnListenerSaga),
        fork(getDevBoxAddOnListenerSaga),
        fork(enableDevBoxAddOnListenerSaga),
        fork(enableDevBoxAddOnWithPollingListenerSaga),
        fork(enableDevBoxAddOnWithPollingAcceptedListenerSaga),
        fork(createOrReplaceDevBoxAddOnListenerSaga),
        fork(enableDevBoxTunnelListenerSaga),
    ]);
}
